import { defineStore } from 'pinia'
import { getLoginInfo } from '@/util/http'
import { resolveRoutePermission } from '@/router/permission'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    permissions: []
  }),
  actions: {
    init() {
      try {
        const loginInfo = getLoginInfo()
        if (loginInfo?.permissions) {
          this.refresh(loginInfo.permissions)
        }
      } catch (error) {
        console.error('恢复权限失败:', error)
      }
    },
    refresh(permissions) {
      this.permissions = Array.isArray(permissions) ? [...permissions] : []
    },
    clear() {
      this.permissions = []
    },
    has(uri) {
      return this.permissions.some((granted) => granted === uri)
    },
    hasAny(uris) {
      return uris.some((it) => this.has(it))
    },
    hasAll(uris) {
      return uris.every((it) => this.has(it))
    },
    checkRoute(to) {
      const permission = resolveRoutePermission(to)
      if (permission === false) return true
      if (Array.isArray(permission)) return this.hasAny(permission)
      return this.has(permission)
    }
  }
})
